// 画面に出す文(英語)。キーは ja.js と同じ(並びもそろえる)。無いキーは日本語が出る。
// ミラの一言は短く、明るく(画面の上に大きく出るので、1行に収まる長さに)。

export default {
  // ---- 共通 ----
  "list.sep": ", ",
  "lang.auto": "AUTO",
  "lang.toggle": "日本語",

  // ---- タイトル ----
  "title.subtitle": "Survive for 3 minutes.",
  "title.start": "LAUNCH",
  "title.hangar": "HANGAR",
  "title.howto1": "Move: WASD / Arrow keys / Gamepad / Drag on screen",
  "title.howto2": "All attacks are automatic. Collect XP and pick upgrades.",
  "title.howto3": "Shot down? Use R.W.N.D. to go back to any moment.",
  "title.sister": "The real battlefield: SENSEOFVOID",
  "title.credits": "BGM: MFP [Marron Fields Production] / SFX: OtoLogic (CC BY 4.0), Koukaon Lab / Some images generated with Google Gemini, operator portraits with ChatGPT / Three.js",
  "title.meta": "{dopa} DOPA · Best distance {progress} · Most kills {kills}",
  "install.button": "Add to Home Screen",
  "install.title": "Add to Home Screen",
  "install.ios": "Tap Safari's Share button (a square with an up arrow; at the bottom on iPhone, top right on iPad), then choose \"Add to Home Screen\". If you opened this inside an app like LINE or X, open it in Safari first.",
  "install.android": "Open your browser's menu (⋮ at the top right) and choose \"Add to Home screen\" or \"Install app\".",
  "install.note": "Launch it from your Home Screen to play full screen without the address bar.",
  "install.close": "OK",

  // ---- 試合中の表示 ----
  "hud.pause": "Pause",
  "hud.camera": "Switch view",
  "hud.holdLeft": "{n} LEFT",
  "banner.approach": "Enemy squadron incoming",
  "banner.advance": "Advance resumed",
  "banner.bossEscape": "Mothership retreating",
  "choice.toast": "{name}: {desc}",
  "choice.toastLv": "{name} Lv{level}: {desc}",

  // ---- Power saving ----
  "sleep.title": "Power saving",
  "sleep.resume": "Tap (or click) the screen to resume",
  "rotate.title": "Please turn your phone upright",
  "rotate.sub": "This game is played in portrait mode",

  // ---- ポーズ ----
  "pause.resume": "Resume",
  "pause.rewind": "R.W.N.D. ({n} left)",
  "pause.quality": "Graphics",
  "pause.camera": "View",
  "pause.lang": "Language",
  "pause.quit": "Back to title",
  "pause.howto": "How to play (Mila's briefing)",
  "sound.on": "Sound ON",
  "sound.off": "Sound OFF",

  // ---- 視点 ----
  "camera.chase": "Chase",
  "camera.high": "High angle",
  "camera.cockpit": "Cockpit",

  // ---- 初めての出撃の前のミラの説明 ----
  "tutorial.say1": "Just remember these!",
  "tutorial.say2": "Try not to bump into things.",
  "tutorial.next": "Next",
  "tutorial.launch": "Launch!",
  "tutorial.close": "Close",
  "tutorial.goodTitle": "GRAB THESE",
  "tutorial.gem": "Gold diamonds",
  "tutorial.gemNote": " (XP)",
  "tutorial.gemDesc": "Collect them to level up and pick upgrades",
  "tutorial.repair": "Green crosses",
  "tutorial.repairNote": " (repair capsules)",
  "tutorial.repairDesc": "Restore your SHIELD",
  "tutorial.badTitle": "AVOID THESE",
  "tutorial.pod": "Pods",
  "tutorial.podNote": " (colored balls)",
  "tutorial.podDesc": "Bumping into them drains SHIELD. Attacks are automatic, so don't get too close",
  "tutorial.shot": "Red shots and beams",
  "tutorial.shotDesc": "Getting hit drains SHIELD. Dodge sideways",

  // ---- 撃墜・リプレイ・R.W.N.D. ----
  "dead.rewind": "R.W.N.D. ({n} left)",
  "dead.result": "Results",
  "replay.rewindHere": "R.W.N.D. from here ({n} left)",
  "replay.close": "Close",
  "replay.photo": "Save photo",
  "replay.photoSaved": "Saved",
  "replay.photoShared": "Shared",
  "replay.photoFailed": "Could not save",
  "replay.photoText": "A highlight from SENSEOFDOPA STAGE {n}. Survive for 3 minutes.",
  "rescue.head": "Restart bonus (DOPA {dopa}) · Brief invincibility after rewinding",
  "rescue.item": "{name}: {desc} ({cost} DOPA)",
  "boost.heal.name": "Repair",
  "boost.heal.desc": "Full SHIELD",
  "boost.power.name": "Power boost",
  "boost.power.desc": "{seconds}s, attack ×{damage}",

  // ---- 結果 ----
  "result.clearText": "Nice work! You can pick the next stage from the stage cards.",
  "result.failText": "That's it for this run. Power up in the hangar and try again.",
  "result.bestNew": "(New best!)",
  "result.bestWas": "(Best {v})",
  "result.progress": "Distance {v} {best}",
  "result.kills": "Kills {v} {best}",
  "result.comboLevel": "Max combo {combo} / Level {level}",
  "result.score": "SCORE {v} {best}",
  "result.retry": "Try again",
  "result.replay": "Watch replay",
  "result.sister": "To the real battlefield: SENSEOFVOID",
  "result.newRecord": "NEW RECORD: {list}",
  "result.achieved": "Goal achieved!",
  "result.nextGoals": "Next goals",
  "earned.score": "SCORE",
  "earned.clear": "Clear",
  "record.progress": "Distance",
  "record.score": "SCORE",
  "record.kills": "Kills",
  "record.combo": "Max combo",
  "record.level": "Level",
  "shop.ready": "You can upgrade \"{name}\" in the hangar!",
  "shop.short": "{n} DOPA to the next upgrade: \"{name}\"",

  // ---- 格納庫 ----
  "hangar.back": "Back",
  "hangar.upgrades": "Upgrades",
  "hangar.max": "MAX",
  "hangar.startWeapon": "Starting weapon",
  "hangar.none": "None",
  "hangar.records": "Records",
  "hangar.goals": "Goals {done}/{all}",
  "hangar.rewindEffect": "+{n}",
  "hangar.shield.name": "Armor",
  "hangar.shield.desc": "Max SHIELD",
  "hangar.power.name": "Power",
  "hangar.power.desc": "All attack power",
  "hangar.xpGain.name": "Learning",
  "hangar.xpGain.desc": "XP gained",
  "hangar.magnet.name": "Collector",
  "hangar.magnet.desc": "XP pickup range",
  "hangar.rewind.name": "R.W.N.D.",
  "hangar.rewind.desc": "R.W.N.D. uses",
  "rec.bestProgress": "Best distance {v}",
  "rec.bestScore": "Best SCORE {v}",
  "rec.bestKills": "Most kills {v}",
  "rec.bestCombo": "Max combo {v}",
  "rec.runs": "Sorties {runs} / Clears {clears}",
  "rec.totalKills": "Total kills {v}",

  // ---- 目標 ----
  "goal.reward": "{n} DOPA",
  "goal.rewardWeapon": "{n} DOPA + weapon",
  "goal.unlock": "Unlocked: start with {weapon}",
  "goal.reach": "Reach {place}",
  "goal.kills": "{n} kills in one run",
  "goal.combo": "{n} combo",
  "goal.level": "Reach level {n} in one run",
  "goal.boss": "Sink the mothership",
  "goal.clear": "Clear stage 3",
  "goal.clear-norewind": "Clear stage 3 without R.W.N.D.",

  // ---- 武器・強化 ----
  "weapon.beam.name": "Beam Cannon",
  "weapon.beam.desc": "Auto-targets nearby enemies",
  "weapon.spread.name": "Spread Beam",
  "weapon.spread.desc": "Fires an expanding ring of beams forward",
  "weapon.missile.name": "Homing Missile",
  "weapon.missile.desc": "Chases enemies and explodes",
  "weapon.saber.name": "Beam Saber",
  "weapon.saber.desc": "Orbits your ship, slicing enemies at your sides",
  "weapon.mainGun.name": "Main Gun",
  "weapon.mainGun.desc": "Now and then fires a huge piercing beam ahead",
  "weapon.beam.evo.name": "Mega Beam",
  "weapon.spread.evo.name": "Storm Ripple",
  "weapon.missile.evo.name": "Cluster Missiles",
  "weapon.saber.evo.name": "Saber Storm",
  "weapon.mainGun.evo.name": "Gravity Cannon",
  "weapon.beam.evo.desc": "Fires a storm of thick beams",
  "weapon.spread.evo.desc": "Sends out huge rings of beams one after another",
  "weapon.missile.evo.desc": "Swarms of missiles bomb a wide area",
  "weapon.saber.evo.desc": "Many blades sweep a wide circle",
  "weapon.mainGun.evo.desc": "Fires a massive beam that swallows everything ahead",
  "choice.evolve": "{from} evolves! {desc}",
  "choice.evoHint": "evolves with {passive} Lv{lv}",
  "choice.evoTag": "EVO",
  "hud.power": "Attack +{p}%",
  "hud.chart": "Upgrade status",
  "chart.title": "STATUS",
  "chart.pickHint": "Tap an orange name to pick that upgrade",
  "chart.levelupTip": "Open the chart to pick while seeing how each upgrade grows. Tap an orange name to choose",
  "chart.close": "Close",
  "chart.evolved": "Gold = evolved",
  "passive.power.name": "Power+",
  "passive.power.desc": "Raises all attack power",
  "passive.haste.name": "Cooling+",
  "passive.haste.desc": "Weapons fire more often",
  "passive.thruster.name": "Thrusters+",
  "passive.thruster.desc": "Move faster",
  "passive.magnet.name": "Magnet+",
  "passive.magnet.desc": "Pulls in XP from farther away",
  "passive.shield.name": "SHIELD+",
  "passive.shield.desc": "Raises max SHIELD and repairs it",
  "heal.name": "SHIELD Repair",
  "heal.desc": "Restores {n} SHIELD",
  "choice.newWeapon": "New weapon: {desc}",

  // ---- ステージ ----
  "stage.orbit.place": "Earth Orbit",
  "stage.orbit.mila": "Earth orbit. Let's go!",
  "stage.orbit.hint": "Shoot the glowing supply satellites for XP and repair capsules",
  "stage.asteroid.place": "the Asteroid Belt",
  "stage.asteroid.mila": "Asteroid belt ahead.",
  "stage.asteroid.hint": "Red-glowing rocks drift in. You can shoot them apart",
  "stage.colony.place": "the Abandoned Colony",
  "stage.colony.mila": "Entering the abandoned colony.",
  "stage.colony.hint": "Stay away from the red laser fences",
  "stage.moon.place": "the Lunar Surface",
  "stage.moon.mila": "Over the moon. The mothership's coming!",
  "stage.moon.hint": "Watch out for ground flak and mines",
  "stage.atmosphere.place": "Atmospheric Entry",
  "stage.atmosphere.mila": "Atmospheric entry! One minute left!",
  "stage.atmosphere.hint": "The screen edges are hot. Stay in the middle",

  // ---- 敵が初めて出たとき ----
  "enemy.dasher.mila": "Red pods incoming!",
  "enemy.dasher.hint": "Red pod: charges straight at you. Dodge sideways",
  "enemy.gunner.mila": "Blue pods are shooting!",
  "enemy.gunner.hint": "Blue pod: stops and fires shots. Take it out first",
  "enemy.splitter.mila": "Purple pods!",
  "enemy.splitter.hint": "Purple pod: splits in two when destroyed",
  "enemy.mine.mila": "Careful, yellow pods!",
  "enemy.mine.hint": "Yellow pod: stops near you and explodes. Shoot it to catch others in the blast",

  // ---- 停止戦 ----
  "hold.miniboss.mila": "A mini mothership!",
  "hold.miniboss.hint": "Halted: destroy everything, mini mothership included, to advance",
  "hold.wave2.mila": "Surrounded again!",
  "hold.wave3.mila": "So many… keep moving!",
  "hold.bigpod.mila": "The big pod… last enemy!",
  "hold.bigpod.hint": "Big pod: aim for the bands top and bottom for big damage",

  // ---- ミラの一言と遊び方の説明 ----
  "mila.start": "Launching!",
  "hint.start": "Just move. All attacks are automatic",
  "mila.repaired": "Repaired!",
  "mila.holdDefault": "We're surrounded!",
  "mila.holdClear": "All clear!",
  "hint.holdClear": "Grab the reward repair capsule (green cross)",
  "mila.boss": "Mothership incoming!",
  "hint.boss": "Stay out of the mothership's main gun (straight ahead)",
  "mila.cannon": "Main cannon charging! Move!",
  "hint.cannon": "The yellow ring is its aim. Slide away before it fires",
  "mila.kill.boss": "Mothership down! Amazing!",
  "mila.kill.miniboss": "Mini mothership down!",
  "mila.kill.bigpod": "Big pod down! You did it!",
  "mila.kill.other": "Destroyed!",
  "mila.timeLeft": "{n} min left!",
  "mila.bossEscape": "The mothership got away... Let's make up for it!",
  "mila.kills100": "100 kills!",
  "mila.levelUp": "Pick an upgrade!",
  "hint.levelUp": "Not sure? New weapons are a good pick",
  "mila.dead": "We can still do this!",
  "mila.deadNoStock": "You did great…",
  "hint.dead": "R.W.N.D.: go back to any moment and try again",
  "mila.rewindBoth": "Again! With repairs and a power boost!",
  "mila.rewindHeal": "Again! I fixed your SHIELD.",
  "mila.rewindPower": "Again! Push through with the power boost!",
  "mila.rewind": "Again! Brief invincibility. Try a different move!",

  // ---- Stage cards / stage clear ----
  "result.stages": "Select stage",
  "result.retrySame": "Retry this stage",
  "result.newStage": "STAGE {n} unlocked!",
  "stages.locked": "Clear STAGE {n} to unlock",
  "stages.desc": "Last enemy: {finale} · about {min} min",
  "stages.allClear": "All stages cleared! Power up in the hangar and aim higher.",
  "finale.miniboss": "Small mothership",
  "finale.boss": "Mothership",
  "finale.bigpod": "Large pod",
  "result.stageGoals": "STAGE {n} goals",
  "stagegoal.clear": "Clear this stage",
  "stagegoal.norewind": "Clear without R.W.N.D.",
  "stagegoal.allholds": "Clear with every hold wiped out",
  "stagegoal.short.clear": "CLEAR",
  "stagegoal.short.norewind": "NO R.W.N.D.",
  "stagegoal.short.allholds": "ALL WIPED",
  "mc.link": "Play SENSEOFVOID",
  "mc.next": "Results",
  "hold.finalMiniboss.mila": "Small mothership! Take it down to clear!",
  "hold.finalMiniboss.hint": "Halted: defeat the small mothership to clear",
  "mission.1.clear": "Getting the hang of it? Want to try the next one?",
  "mission.2.clear": "Let's see how far you can go.",
  "mission.3.clear": "You made it this far, so I have a favor to ask. Fight with me on the real battlefield, SENSEOFVOID.",
  "mission.4.clear": "That's real skill. Will you show it on the SENSEOFVOID battlefield too?",
  "mission.5.clear": "Amazing...! I'll be waiting for a pilot like you in SENSEOFVOID.",
  "mission.6.clear": "Every stage cleared! Thank you so much. See you in SENSEOFVOID.",
};
